export default "__VITE_ASSET__C0X3izBQ__";